import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import './style.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import {
  fetchBlogs,
  deleteBlogs,
  toggleBlogSelection,
  toggleAllBlogSelection,
  setPage,
} from '../../store/Blog/blogSlice';

const BlogPosts = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { blogs, currentPage, totalPages, totalBlogs, loading, error, selectedBlogs } = useSelector(
    state => state.blogs
  );

  const [filters, setFilters] = useState({
    category: '',
    status: '',
    date: '',
  });

  useEffect(() => {
    dispatch(fetchBlogs({ page: currentPage, limit: 10, ...filters }));
  }, [dispatch, currentPage, filters]);

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters(prev => ({ ...prev, [name]: value }));
    dispatch(setPage(1)); // Reset to page 1 on filter change
  };

  const handleBulkAction = async (action) => {
    if (action === 'delete' && selectedBlogs.length > 0) {
      await dispatch(deleteBlogs(selectedBlogs));
      dispatch(fetchBlogs({ page: currentPage, limit: 10, ...filters }));
    }
  };

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      dispatch(setPage(page));
    }
  };

  const handleAddNewPost = () => {
    navigate('/blogs/create');
  };

  return (
    <div style={{ background: '#F6F6F6' }}>
      <div className="product-wrap col-md-10 mx-auto mt-3 p-3">
        <div className="Container">
          <h2>Blog Posts</h2>
          <button className="btn-cls" onClick={handleAddNewPost}>
            Add New Post
          </button>

          {error && <div className="alert alert-danger">{error}</div>}
          {loading && <div>Loading...</div>}

          <div className="filter mt-3">
            <div className="w-100">
              <div className="row">
                <div className="col-md-8 d-flex">
                  <div className="frm-outer">
                    <select
                      className="form-control form-select px-4"
                      onChange={e => handleBulkAction(e.target.value)}
                    >
                      <option value="">Bulk Action</option>
                      <option value="delete">Delete</option>
                    </select>

                    <button className="btn-cls" onClick={() => handleBulkAction('delete')}>
                      Apply
                    </button>

                    <select
                      className="form-control form-select px-4"
                      name="date"
                      value={filters.date}
                      onChange={handleFilterChange}
                    >
                      <option value="">All Dates</option>
                      {/* Populate with actual date options if needed */}
                      <option value="2025-05">May 2025</option>
                    </select>

                    <select
                      className="form-control form-select"
                      name="category"
                      value={filters.category}
                      onChange={handleFilterChange}
                    >
                      <option value="">All Categories</option>
                      {/* Populate dynamically from API if available */}
                      <option value="Time Management">Time Management</option>
                    </select>

                    <select
                      className="form-control form-select px-4"
                      name="status"
                      value={filters.status}
                      onChange={handleFilterChange}
                    >
                      <option value="">All Statuses</option>
                      <option value="Draft">Draft</option>
                      <option value="Published">Published</option>
                    </select>

                    <button className="btn-cls" onClick={() => dispatch(fetchBlogs({ page: 1, limit: 10, ...filters }))}>
                      Filter
                    </button>
                  </div>
                </div>

                <div className="col-md-4 right-align pagination-cls">
                  <nav aria-label="Page navigation example">
                    <ul className="pagination">
                      <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                        <button
                          className="page-link"
                          onClick={() => handlePageChange(currentPage - 1)}
                          aria-label="Previous"
                        >
                          <span aria-hidden="true">«</span>
                          <span className="sr-only">Previous</span>
                        </button>
                      </li>
                      {Array.from({ length: totalPages }, (_, i) => i + 1).map(page => (
                        <li key={page} className={`page-item ${currentPage === page ? 'active' : ''}`}>
                          <button className="page-link" onClick={() => handlePageChange(page)}>
                            {page}
                          </button>
                        </li>
                      ))}
                      <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                        <button
                          className="page-link"
                          onClick={() => handlePageChange(currentPage + 1)}
                          aria-label="Next"
                        >
                          <span aria-hidden="true">»</span>
                          <span className="sr-only">Next</span>
                        </button>
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>
            </div>
          </div>

          <div className="blog-inner pt-3">
            <table className="table table-striped">
              <thead>
                <tr>
                  <th>
                    <input
                      type="checkbox"
                      className="form-check-input"
                      checked={blogs.length > 0 && blogs.every(blog => blog.selected)}
                      onChange={e => dispatch(toggleAllBlogSelection(e.target.checked))}
                    />
                  </th>
                  <th>Title</th>
                  <th>Author</th>
                  <th>Blog Categories</th>
                  <th>Tags</th>
                  <th>Date</th>
                </tr>
              </thead>
              <tbody>
                {blogs.map(blog => (
                  <tr key={blog._id}>
                    <td>
                      <input
                        type="checkbox"
                        className="form-check-input"
                        checked={blog.selected || false}
                        onChange={() => dispatch(toggleBlogSelection(blog._id))}
                      />
                    </td>
                    <td>
                      <Link to={`/blogs/view/${blog._id}`}>{blog.title}</Link> — {blog.status}
                    </td>
                    <td>{blog.author?.username || 'Unknown'}</td>
                    <td>{blog.categories?.map(cat => cat.name).join(', ') || 'None'}</td>
                    <td>{blog.tags?.map(tag => tag.name).join(', ') || '—'}</td>
                    <td>Last Modified <br />{new Date(blog.updatedAt).toLocaleString()}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BlogPosts;